import DeviceDetector from "device-detector-js";

export function obtenerInformacionNavegador() {
    const deviceDetector = new DeviceDetector();
    const device = deviceDetector.parse(window.navigator.userAgent);
    return device;
}